<template>
	<template v-if="languagesStore.isLoaded">
		<contact-us-modal v-if="currentSite.contactUs"/>
		<layout-header/>
		<main>
			<router-view/>
		</main>
		<layout-footer :class="{'layout-footer--pending': !layoutStore.contentReady}"/>
	</template>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import LayoutHeader from "../Components/Layout/LayoutHeader.vue";
import LayoutFooter from "../Components/Layout/LayoutFooter.vue";
import {useLanguagesStore} from "../Stores/LanguagesStore";
import {LayoutCssVariables} from "../Utils/LayoutCssVariables";
import {useSiteCheckStore} from "../Stores/SiteCheck/SiteCheck";
import {useLayoutStore} from "../Stores/LayoutStore";
import ContactUsModal from "@/WebApp/Modals/ContactUsModal.vue";
import {SiteCheckInterface} from "@/WebApp/Stores/SiteCheck/Interfaces/SiteCheckInterface";

export default defineComponent({
	name: "App",
	components: {ContactUsModal, LayoutFooter, LayoutHeader},
	setup() {
		return {
			languagesStore: useLanguagesStore(),
			siteStore: useSiteCheckStore(),
			layoutStore: useLayoutStore(),
		}
	},
	mounted() {
		setTimeout(() => this.layoutStore.markContentReady(), 5000);

		this.siteStore.getSite();
		this.languagesStore.getTranslationList();

		if (window.location.hash) {
			const hash = window.location.hash;
			setTimeout(() => {
				this.jumpToHash(hash);
			},1000);
		}
	},
	computed: {
		bgColor(): string {
			return `var(--${LayoutCssVariables.page.bgColor})`;
		},
		currentSite(): SiteCheckInterface {
			return this.siteStore.currentSite;
		}
	},
	methods: {
		jumpTo(e) {
			e.preventDefault();
			const href = e.target.getAttribute('href');
			this.scrollToElement(href);
		},
		jumpToHash(hash: string) {
			this.scrollToElement(hash);
		},
		scrollToElement(selector: string) {
			const element = document.querySelector(selector);
			if(element) {
				const elementPosition = element.getBoundingClientRect().top + window.scrollY;
				window.scrollTo({
					top: elementPosition - 20,
					behavior: "smooth",
				});
			}
		}
	}
});
</script>

<style scoped>
main {
	background-color: v-bind(bgColor);
}
</style>
